import { createVanIconComponent } from "./van"

const HotSaleOutlined = createVanIconComponent("hot-sale-o")
export default HotSaleOutlined
